export enum Constant {
    BACKEND_API_BASE_URL = 'https://api.meso.stream/',
    // BACKEND_API_BASE_URL = 'http://localhost:8000/',
}